import { useState, useCallback } from 'react';
import { useApiClientsOrNull } from '../context/ApiClientsContext';
import { followPublisher, unfollowPublisher } from '../api/marketplaceApi';

export interface UseFollowPublisherResult {
  toggling: boolean;
  toggle: (slug: string, isCurrentlyFollowed: boolean) => Promise<{ isFollowed: boolean; followerCount: number } | null>;
}

export function useFollowPublisher(): UseFollowPublisherResult {
  const apiClients = useApiClientsOrNull();

  const [toggling, setToggling] = useState(false);

  const toggle = useCallback(
    async (slug: string, isCurrentlyFollowed: boolean) => {
      if (!apiClients) return null;

      setToggling(true);
      try {
        const res = isCurrentlyFollowed
          ? await unfollowPublisher(apiClients.schemaClient, slug)
          : await followPublisher(apiClients.schemaClient, slug);
        return { isFollowed: res.isFollowed, followerCount: res.followerCount };
      } catch {
        return null;
      } finally {
        setToggling(false);
      }
    },
    [apiClients]
  );

  return { toggling, toggle };
}
